<template lang="pug">
  DataTablePage(
    pid="parentId"
    cid="id"
    mainColumn="name"
    longColumn="name"
    resource="rbac/org"
    title="组织架构管理"
    label="组织"
    labelName="name"
    :isTree="true"
    :toolbar="toolbar"
    :operation="operation"
    :operationWidth=240
    :tableFullList="tableFullList"
    :tableInitList="tableInitList"
    :filterFullList="filterFullList"
    :filterInitList="filterInitList"
    :createList="createList"
    :updateList="updateList"
    :createFormValues="createFormValues"
    :columns="columns")
</template>

<script>
import DataTablePage from '@/containers/DataTablePage'
import { toolbarCreate } from '@/containers/DataTablePage/toolbar'
import { operationCreate, operationUpdate, operationDelete } from '@/containers/DataTablePage/operation'
import { checkActions, expire } from '@/utils/auth'

export default {
  name: 'SystemOrganization',
  components: {
    DataTablePage
  },
  mounted () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
  },
  data () {
    const hasUpdate = checkActions('/system/menu/update')
    const hasCreate = checkActions('/system/menu/create')
    const hasDelete = checkActions('/system/menu/delete')
    return {
      toolbar: [{
        ...toolbarCreate,
        isShow () {
          return checkActions('/system/menu/create')
        }
      }],
      operation: [{
        ...operationCreate,
        isShow () {
          return hasCreate
        }
      }, {
        ...operationUpdate,
        isShow () {
          return hasUpdate
        }
      }, {
        ...operationDelete,
        isShow () {
          return hasDelete
        }
      }],
      tableInitList: ['name', 'orgTypeName', 'enabled', 'remark'],
      tableFullList: ['name', 'orgTypeName', 'enabled', 'remark'],
      filterInitList: ['name', 'orgTypeId', 'enabled'],
      filterFullList: ['name', 'orgTypeId', 'enabled'],
      createList: ['name', 'orgTypeId', 'enabled', 'parentId', 'remark'],
      updateList: ['name', 'orgTypeId', 'enabled', 'parentId', 'remark'],
      createFormValues: {
        parentId: '',
        name: '',
        orgTypeId: '',
        enabled: 1,
        remark: ''
      },
      columns: {
        name: {
          label: '组织名称',
          filter: {
            type: 'input',
            like: true
          },
          form: {
            type: 'input',
            rules: [{
              type: 'required',
              message: '请输入组织名称'
            }, {
              type: 'maxLength',
              value: 30,
              message: '长度不能大于30'
            }]
          }
        },
        parentId: {
          label: '上级组织ID',
          form: {
            type: 'hidden',
            dataSource: 'string'
          }
        },
        orgTypeId: {
          label: '组织类型',
          relation: 'orgType',
          filter: {
            type: 'select',
            width: 100
          },
          form: {
            type: 'select',
            rules: [{
              type: 'required',
              message: '请输入组织类型'
            }]
          }
        },
        orgTypeName: {
          label: '组织类型',
          width: 98,
          filter: {
            type: 'input',
            like: true
          }
        },
        enabled: {
          label: '是否可见',
          width: 98,
          type: 'select',
          relation: 'yesOrNo',
          filter: {
            type: 'select',
            width: 100
          },
          form: {
            type: 'select',
            width: 100,
            rules: [{
              dataType: 'boolean',
              type: 'required',
              message: '请输入是否可见'
            }]
          }
        },
        remark: {
          label: '备注',
          width: 140,
          form: {
            type: 'input',
            isColumn: true,
            large: true,
            rules: [{
              type: 'maxLength',
              value: 120,
              message: '字数不能大于120个字'
            }]
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Organization.vue?23bafc73